module.exports = __webpack_public_path__ + "static/img/0.3cb041b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0.jpg
// module id = 5e9m
// module chunks = 57